import type { App } from "@pentacode/core";
import type { QueryClient } from "@tanstack/query-core";
import { redirect } from "@tanstack/router-core";
import { createRootRouteWithContext } from "../lib/tsr/router";

export interface AppRouterContext {
    app: App;
    queryClient: QueryClient;
    /**
     * "app": routes render inside the manage app's shell (menus, legacy
     * sections). "view": a single embedded `<pentacode-view>`, no navigation
     * chrome.
     */
    mode: "app" | "view";
    /** Inside a partner page, as `<pentacode-app>` or `<pentacode-view>`. */
    embedded: boolean;
    /** The app refused `path` and redirected elsewhere; embedded hosts get told. */
    reportDenied: (path: string) => void;
}

export function createAppRootRoute() {
    return createRootRouteWithContext<AppRouterContext>()({});
}

export type AppRootRoute = ReturnType<typeof createAppRootRoute>;

/**
 * A redirect to a path the type system can't see statically (computed page
 * ids); typed redirects stay preferable wherever the target is a literal.
 */
export function redirectTo(path: string, search: Record<string, unknown> = {}, replace = true): never {
    throw redirect({ to: path as "/", search: () => search as never, replace });
}
